import { useState, useEffect } from "react";

import { Tooltip, Box, Modal, Stack } from "@mui/material";
import { Visibility, Close, } from "@mui/icons-material";

import { D, C, openLink } from "../include";

const style = {
  overflow: 'hidden',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: '90vw',
  minWidth: '70vw',
  minHeight: '60vh',
  maxHeight: '90vh',
  bgcolor: 'background.paper',
  borderRadius: '1rem',
  boxShadow: 24,
  p: 4,
  display: 'flex',
  flexDirection: 'column',
  padding: '1rem',
  position: "absolute"
};

export const TimelineCard = ({ doc_id, api, stateCard, onCloseCard }) => {
  const [cardBody, setCardBody] = useState([]);
  const [cardImg, setCardImg] = useState('');

  useEffect(() => {
    let isMounted = true;

    api.get(`Timeline/documentos/${doc_id}`)
      .then(r => {
        if (isMounted && r && r.length > 0) {
          setCardBody(r);
          setCardImg(r[0].thumb_png);
        }
      })
      .catch(err => {
        console.error("Erro ao carregar detalhes do documento na TimelineCard:", err);
      });

    // Função de cleanup: evita atualizar estado se o componente desmontar antes da promessa resolver
    return () => {
      isMounted = false;
    };
  }, [api, doc_id]);

  return (
    <Modal
      open={stateCard}
      onClose={onCloseCard}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <header 
          style={{ 
            paddingBottom: "6px", 
            borderBottom: "1px solid gray", 
            flexDirection: 'row', 
            display: 'flex', 
            justifyContent: 'space-between' 
          }}
        >
          <div>
            <h2 style={{ padding: 0, margin: 0, color: "#3f3f3f" }}>Detalhes</h2>
          </div>
          <div style={{ textAlign: 'end', padding: 0, margin: 0 }}>
            <Close 
              onClick={onCloseCard} 
              sx={{ ":hover": { color: 'grey', backgroundColor: 'white' }, cursor: 'pointer' }} 
            />
          </div>
        </header>
        
        <div style={{ display: 'flex', flexDirection: 'row', position: 'relative', overflowY: 'auto', height: 'calc(100% - 72px)' }}>
          <div style={{ width: "50%" }}>
            {cardImg && (
              <img 
                style={{ width: "100%", boxSizing: "border-box" }}
                src={`${C.baseURL}pic/${cardImg}`} 
                alt="Thumbnail do documento" 
              />
            )}
          </div>

          <D className="col e aF" style={{ display: 'flex', width: '50%' }}>
            <D col style={{ padding: '7px' }}>
              <span style={{ fontWeight: 'bold', color: '#7a7a7a' }}>Número do documento:</span>
              <span style={{ fontWeight: '100' }}>{doc_id}</span>
            </D>
            {cardBody.map(e => (
              <D key={e.qualificador_id} col style={{ padding: '7px' }}>
                <span style={{ fontWeight: 'bold', color: '#7a7a7a' }}>{e.qualificador_nome}:</span>
                <span style={{ fontWeight: '100' }}> {e.valor_final}</span>
              </D>
            ))}
          </D>
        </div>
        
        <footer 
          style={{ 
            height: "50px", 
            paddingTop: "6px", 
            borderTop: "1px solid gray", 
            bottom: 0, 
            display: "flex", 
            flexDirection: "row-reverse", 
            paddingRight: "1rem", 
            alignItems: "center", 
            gap: "10px" 
          }}
        >
          <Stack spacing={1} direction='row'>
            <Tooltip title="Abrir painel de leitura" arrow>
              <Visibility 
                height="48px" 
                className="hv" 
                color="action" 
                style={{ cursor: 'pointer' }}
                onClick={() => openLink(`/viewer.html?p=${doc_id}`)} 
              />
            </Tooltip>
          </Stack>
        </footer>
      </Box>
    </Modal>
  );
};
